import React, { useEffect } from "react";
import { Spin } from "antd";
import { ArrowLeftOutlined, AppstoreOutlined } from "@ant-design/icons";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchProjectDetail } from "../../redux/actions";
import ManageJobCard from "../ManageJobs/components/ManageJobCard";
import { ReactComponent as ProjectIcon } from "../../assets/icons/ProjectIcon.svg";
import "./ProjectDetail.css";
import "./ProjectJobs.css";

export default function ProjectJobs() {
  const history = useHistory();
  const { id } = useParams();
  const dispatch = useDispatch();

  const { project, jobs, counts, loading } = useSelector(
    (state) => state.projectDetailReducer
  );

  useEffect(() => {
    if (id) dispatch(fetchProjectDetail(id));
  }, [id]);

  if (loading && !project) {
    return (
      <div className="pd-loading">
        <Spin size="large" />
      </div>
    );
  }

  const jobCount = counts?.jobsCount ?? (jobs || []).length;

  return (
    <div className="pd-page pj-page">
      {/* ── Header ── */}
      <div className="pj-header">
        <div className="pj-header-inner">
          <button
            className="pd-back-btn"
            onClick={() => history.push(`/manage-projects/${id}`)}
          >
            <ArrowLeftOutlined />
          </button>

          <div className="pj-header-icon">
            <ProjectIcon />
          </div>

          <div className="pj-header-text">
            <span className="pj-project-name">{project?.projectName || "—"}</span>
            <span className="pj-header-divider">›</span>
            <span className="pj-page-label">All Jobs</span>
          </div>

          <span className="pj-count-badge">{jobCount} job{jobCount !== 1 ? "s" : ""}</span>
        </div>
      </div>

      {/* ── Content ── */}
      <div className="pj-content">
        {(jobs || []).length > 0 ? (
          <div className="pd-jobs-grid">
            {(jobs || []).map((job) => {
              const loc = job.location;
              const locationStr =
                typeof loc === "string"
                  ? loc
                  : loc?.LocationWithCountry ||
                    loc?.Location ||
                    loc?.LocationLong ||
                    [job.Cities?.CityName, job.Regions?.Code].filter(Boolean).join(", ") ||
                    "";
              return (
                <ManageJobCard
                  key={job.jobOrderId || job._id || job.id}
                  job={{
                    ...job,
                    id: job.jobOrderId || job.id || job._id,
                    JobOrderId: job.jobOrderId || job.JobOrderId,
                    location: locationStr,
                    facilityname: job.companyName || job.companyname || job.facilityname,
                    matchedbids: job.matches ?? job.counts?.matches ?? job.matchedbids ?? 0,
                    placedbids: job.bidsPlaced ?? job.counts?.bidsPlaced ?? job.placedbids ?? 0,
                    receivedbids: job.bidsReceived ?? job.counts?.bidsReceived ?? job.receivedbids ?? 0,
                    candidates: job.invited ?? job.counts?.invited ?? job.candidates ?? 0,
                    RegionCode: job.location?.RegionCode || job.RegionCode,
                  }}
                />
              );
            })}
          </div>
        ) : (
          <div className="pj-empty">
            <div className="pj-empty-icon">
              {/* <BriefcaseOutlined /> */}
            </div>
            <p className="pj-empty-title">No jobs posted yet</p>
            <p className="pj-empty-sub">Jobs added to this project will appear here.</p>
          </div>
        )}
      </div>
    </div>
  );
}
